import './HowSection.css';
import { FC } from 'react';
import happyImage from '../../../assets/happy.webp';
import { useTranslation } from 'react-i18next';

export const HowSection: FC = () => {
    const { t } = useTranslation();
    return (
        <section className="how">
            <div className="custom-shape-divider-top">
                <svg
                    data-name="Layer 1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 1200 120"
                    preserveAspectRatio="none"
                >
                    <path
                        d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
                        className="shape-fill"
                    ></path>
                </svg>
            </div>
            <div className="how__container container">
                <div className="how__content">
                    <div className="how__image">
                        <img
                            src={happyImage}
                            alt="BalancePath"
                            loading="lazy"
                            fetchPriority="high"
                        />
                    </div>
                    <div className="how__text-column">
                        {/* h2, ne h1 — stranica sme da ima samo jedan h1 (hero u HomePage.tsx) */}
                        <h2 className="how__container_title">{t('home.section2.title')}</h2>
                        <div className="how__explanations">
                            <h3 className="how__title">{t('home.section2.paragraph0.title')}</h3>
                            <p className="how__description">{t('home.section2.paragraph0.subtitle')}</p>
                            <h3 className="how__title">{t('home.section2.paragraph1.title')}</h3>
                            <p className="how__description">{t('home.section2.paragraph1.subtitle')}</p>
                            <h3 className="how__title">{t('home.section2.paragraph2.title')}</h3>
                            <p className="how__description">{t('home.section2.paragraph2.subtitle')}</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
